import styled, { css } from 'styled-components';
import { padding, borderRadius, darken } from 'polished';

export const SelectStyle = styled.div`
    position: relative;
    display: block;
    cursor: pointer;
`;

interface SelectInputProps {
    menuIsOpen?: boolean;
    theme?: any;
}

export const SelectInputStyle = styled.input<SelectInputProps>`
    width: 100%;
    ${({ theme }) => {
        const variables = theme?.variables ?? { padding: 10, borderRadius: '4px' };
        return padding(+variables.padding, +variables.padding * 3.5, +variables.padding, +variables.padding * 1.5);
    }};
    ${({ menuIsOpen, theme }) => {
        const variables = theme?.variables ?? { borderRadius: '4px' };
        return !menuIsOpen ? `border-radius: ${variables.borderRadius}` : borderRadius('top', variables.borderRadius);
    }};
    font-size: inherit;
    background: ${({ theme }) => {
        const colors = theme?.colors ?? {};
        // fallback to valid color string
        return colors.white || '#fff';
    }};
    border: 1px solid
        ${({ menuIsOpen, theme }) => {
            const colors = theme?.colors ?? {};
            const primary = colors.primary || '#007bff';
            const light = colors.light || '#E0E0E0';
            return menuIsOpen ? primary : darken(0.1, light);
        }};
    outline: 0;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover,
    &:focus {
        border: 1px solid ${({ theme }) => theme?.colors?.primary ?? '#007bff'};
    }
`;

export const SelectInputWrapper = styled.div`
    position: relative;
    display: block;
`;

interface SelectIconProps {
    invert?: boolean;
}
export const SelectIcon = styled.span<SelectIconProps>`
    position: absolute;
    top: 2px;
    right: ${({ theme: { variables } }) => +variables.padding * 1.5}px;
    bottom: 2px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 20px;
    color: ${({ theme: { colors }, invert }) => (invert ? colors.primary : darken(0.1, colors.light))};
    font-size: 20px;
    line-height: ${({ invert }) => (invert ? 0 : 2)};

    ${(props) =>
        props.invert &&
        css`
            transform: rotateX(180deg);
        `}
`;

export const SelectMenuStyle = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    z-index: 10;
    max-height: 250px;
    overflow-y: auto;
    color: ${({ theme: { colors } }) => colors.dark};
    background: ${({ theme: { colors } }) => colors.white};
    border: 1px solid ${({ theme: { colors } }) => darken(0.1, colors.light)};
    border-top: 0;
    ${({ theme: { variables } }) => borderRadius('bottom', variables.borderRadius)};
`;

interface SelectMenuItemProps {
    isSelected?: boolean;
    isHighlighted?: boolean;
}

export const SelectMenuItemStyle = styled.div<SelectMenuItemProps>`
    ${({ theme: { variables } }) => padding(variables.padding)};
    border-bottom: 1px solid ${({ theme: { colors } }) => darken(0.025, colors.light)};
    transition: all 0.25s ease;
    ${({ isSelected, isHighlighted, theme: { colors } }) =>
        (isSelected || isHighlighted) && `color: ${darken(0.15, colors.primary)}`};

    &:last-of-type {
        border: 0;
        ${({ theme: { variables } }) => borderRadius('bottom', variables.borderRadius)};
    }

    &:hover {
        color: ${({ theme: { colors } }) => colors.primary};
        background: ${({ theme: { colors } }) => darken(0.01, colors.white)};
    }
`;
